import { composeProps } from '@mews/framework';

import {
    getEnterpriseConfigurationServiceId,
    getEnterprisePaymentCardRequirement,
} from '../../modules/configuration/selectors';
import { selectedEnterpriseIdPropsExtender } from '../../modules/resourceOrder/selectors';

/*
 * If possible, avoid using the contextual selectors from this file in new code. We should instead prefer context-less selectors. It makes code more predictable, testable and components more reusable.
 * For example instead of using wrapper selector `getSelectedEnterprisePaymentCardRequirement`, prefer directly using `getEnterprisePaymentCardRequirement`.
 */

export const getSelectedEnterprisePaymentCardRequirement = composeProps(
    getEnterprisePaymentCardRequirement,
    selectedEnterpriseIdPropsExtender
);
export const getSelectedEnterpriseConfigurationServiceId = composeProps(
    getEnterpriseConfigurationServiceId,
    selectedEnterpriseIdPropsExtender
);
